import React from 'react';
import { Link } from 'react-router-dom';
import {  Button } from 'react-bootstrap';
import { ReceiptCutoff } from 'react-bootstrap-icons';
import '../styles/tables.css';
import TablaFacturas from './componentes/tablaFacturas';

function AdminFacturas() {
    return (
        <div className='mx-2 mt-3'>
            <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'>
                <p className='mb-2 mb-md-0 text-center'>
                    Administra todas las facturas de venta de tu negocio.
                </p>
                <div className='d-flex mt-2 mt-md-0'>
                    <Link to='/admin/Facturas/CrearFactura/'>
                        <Button variant='danger'>
                            <ReceiptCutoff /> Nueva Factura
                        </Button>
                    </Link>
                </div>
            </div>
            {/* Tabla Facturas */}
            <div className='mt-4'>
                <TablaFacturas />
            </div>
        </div>
    );
}

export default AdminFacturas;